exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_core-js@2.6.2@core-js/library/modules/_wks-ext.js
// module id = 159
// module chunks = 0